import { createContext, useEffect, useState } from "react";
import { getPermissions } from "../services/authService";

const PermissionsContext = createContext();

const PermissionsProvider = ({ children, resourceId }) => {

  const [actions, setActions] = useState(new Set([]));
  const [rawActions, setRawActions] = useState([]);
  // const [resourceId, setResourceId] = useState(null);

  useEffect(() => {
    if (resourceId)
      getPermissions(resourceId).then(response => {
        if (response.data.responseCode === 200) {
          setActions(new Set(response.data.load.map(action => action.key)));
          setRawActions(response.data.load);
        }
      });
  }, [resourceId]);

  // const hasPermission = (actionKey) => actions.has(actionKey);

  // const hasPermission = (actionKey, data = undefined) => {

  //   if (data == undefined || data == null) {
  //     return actions.has(actionKey)
  //   }
  //   else {
  //     if (actions.has(actionKey)) {
  //       const matchedAction = rawActions.find(item => item.key === actionKey);
  //       const actionConditions = matchedAction?.conditions || [];

  //       if (actionConditions.length === 0) return true;

  //       for (const condition of actionConditions) {
  //         const { column, condition: op, value } = condition;

  //         const dataValue = data[column];
  //         const conditionValue = value;

  //         switch (op) {
  //           case "=":
  //             if (dataValue != conditionValue) return false;
  //             break;

  //           case "!=":
  //           case "<>":
  //             if (dataValue == conditionValue) return false;
  //             break;

  //           case "<":
  //             if (!(parseFloat(dataValue) < parseFloat(conditionValue))) return false;
  //             break;

  //           case ">":
  //             if (!(parseFloat(dataValue) > parseFloat(conditionValue))) return false;
  //             break;

  //           case "in":
  //             {
  //               const valuesArray = conditionValue.split(",").map(v => v.trim());
  //               if (!valuesArray.includes(dataValue)) return false;
  //             }
  //             break;

  //           default:
  //             console.warn(`Unsupported condition operator: ${op}`);
  //             return false;
  //         }
  //       }

  //     }
  //   }
  // };

    const hasPermission = (actionKey, data = undefined) => {
    if (!actions.has(actionKey)) return false;

    if (data == null || data === undefined) {
      return true;
    }

    const matchedAction = rawActions.find(item => item.key === actionKey);
    const actionConditions = matchedAction?.conditions || [];

    if (actionConditions.length === 0) return true;

    for (const condition of actionConditions) {
      const { column, condition: op, value } = condition;

      const dataValue = data[column]; 
      const conditionValue = value; 

      switch (op) {
        case "=":
          if (dataValue != conditionValue) return false;
          break;

        case "!=":
        case "<>":
          if (dataValue == conditionValue) return false;
          break;

        case "<":
          if (!(parseFloat(dataValue) < parseFloat(conditionValue))) return false;
          break;

        case ">":
          if (!(parseFloat(dataValue) > parseFloat(conditionValue))) return false;
          break;

        case "in":
          {
            const valuesArray = conditionValue.split(",").map(v => v.trim());
            if (!valuesArray.includes(dataValue)) return false;
          }
          break;

        default:
          console.warn(`Unsupported condition operator: ${op}`);
          return false;
      }
    }

    return true;
  };


  return (
    <PermissionsContext.Provider value={{ hasPermission }}>
      {children}
    </PermissionsContext.Provider>
  )
}

export { PermissionsContext, PermissionsProvider }

